export const MSLF = {
  MSLF_IFRAME_APP_ID: "mslf-app-iframe",
  MSLF_APP_ID: "mslf-app",
  MSLF_APP_SCRIPT_ID: "mslf-app-script",
  MSLF_APP_MIN_HEIGHT_PX: 600,
  MSLF_APP_CONFIG_PATH: "multi-step-lead-form",
};

const TCPA_S3_DIRNAME = "tcpa-html";

export const TCPA = {
  TCPA_IFRAME_APP_ID: "tcpa-app-iframe",
  TCPA_APP_ID: "tcpa-app",
  TCPA_APP_SCRIPT_ID: "tcpa-app-script",
  TCPA_S3_BASE_URL: `${process.env.REACT_APP_ASSETS_URL}/${TCPA_S3_DIRNAME}`,
  TCPA_S3_DIRNAME,
};

export const DEFAULT_COMPANY = "HelloProject USA, LLC";
export const GCLID_FIELD_NAME = "gclid";
export const JORNAYA_TCPA_FORM_FIELD_NAME = "leadid_tcpa_disclosure";
export const JORNAYA_TOKEN_FORM_FIELD_NAME = "leadid_token";
export const TRUSTED_FORM_FIELD_NAME = "xxTrustedFormCertUrl";
export const BIDS_FORM_FIELD_NAME = "Match_With_Bid_ID";
export const LS_SUBMISSION_KEY = "hp_lf";
export const LS_SUBMISSION_TIMEOUT = 60 * 30;
